import { Component, OnInit } from '@angular/core';
import { MasterService,AttendanceService,AppraisalService } from '../../services/index';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { AppGlobals } from '../../shared/app.global';
// import "../../../global"

@Component({
  selector: 'app-lecturer',
  templateUrl: './lecturer.component.html',
  styleUrls: ['./lecturer.component.scss'],
   providers:[MasterService,AttendanceService,AppraisalService]
})
export class LecturerComponent implements OnInit {

  sections:any=[];
       classes:any=[];
       fmodel:any={};
       attdata:any=[];
       arrcourse:any=[];
       arrstaff:any=[];
       oprtype:any='';
       tabledata: any = {};
       strattmarked="";
       showload:any="no";
       showsms:any="no";
       objmodel:any={};
       objhdnvalue:any={};
     
      arrrating=[{id:1,val:'1'},{id:2,val:'2'},{id:3,val:'3'},{id:4,val:'4'},{id:5,val:'5'}];
       closeResult: string;
       modalOptions:NgbModalOptions;
       smmodalOptions:NgbModalOptions;
       private modalRef: NgbModalRef;
       private smallmodalRef: NgbModalRef;
     arrquestions: any;
  arrobjteaching: any=[]  ;
  arrteaching: any;
  arrseminar: any;
  arrobjseminar: any=[];
  arrobjrep: any=[];
  arrrep: any=[];
  arrobjres: any=[];
  arrres: any=[];
  arrobjpub: any=[];
  arrpub: any=[];
  arrobjecon: any=[];
  arrecon: any=[];
       constructor(private http: HttpClient,private apservice:AppraisalService,private aservice:AttendanceService, private mservice: MasterService,private modalService: NgbModal,private _global: AppGlobals) { }
     
       ngOnInit(): void {
        //  this.getstaff();
         //this.massection();
          var usid=localStorage.getItem('usid');
          this.getquestions(6,1,usid);
         this.fmodel.attdt=this.mservice.getdatetoday();
         this.objmodel={aynm:'' , sem:'' , subhandle:'' , noclassign:'' , noclastougt:'' , unresults:'' , topicnm:'' , institenm:'' , wkdt:this.fmodel.attdt , place:'' , rectpnm:'' , issnisbnno:'' , impactfactor:'' , noofauthor:'' , mainauthor:'' , recscore:'' , chapternm:'' , econtdet:''};
       }
     
          setfeedback(j,k,l,m,val)
     {
  debugger
     // alert(j);
     this.arrquestions[j].group2[k].group3[l].questions[m].aprqtres=val;
     console.log('clicked',this.arrquestions);
  
     }
   
       getstaff() {
         this.mservice.staffrolewise()
             .subscribe(
             resultArray => {
                 console.log('getdashcounts', resultArray);
                 //resultArray.unshift({emid:"0",emnm:"ALL"});
              //  resultArray.shift();
                 this.arrstaff = resultArray;
                
                 this.fmodel.emid=resultArray[0].emid;
                 // this.amodel.emid=resultArray[0].emid;
                 // this.SelectAttdcorDetails();
                 this.getquestions(6,1,this.fmodel.emid);
             },
             error => console.log("Error :: " + error)
             )
       }
   
   
        getquestions(fmid,stepid,emid) {
         this.apservice.selapprhrtaprd(fmid,stepid,emid)
             .subscribe(
             resultArray => {
                 console.log('getdashcounts', resultArray);
                 
                 this.arrquestions = resultArray;
                this.bindfields();
                 
             },
             error => console.log("Error :: " + error)
             )
       }
   

       bindfields()
       {

          for(let j=0;j<this.arrquestions.length;j++)
         {
   
           for (let k=0;k<this.arrquestions[j].group2.length;k++)
           {
             for(let l=0;l<this.arrquestions[j].group2[k].group3.length;l++)
             {
           for(let i=0;i<this.arrquestions[j].group2[k].group3[l].questions.length;i++)
           {
           let objitm:any={};
           if(this.arrquestions[j].group2[k].group3[l].questions[i].aprqtid == "253")
           {
           this.objhdnvalue.tchaprqtid=this.arrquestions[j].group2[k].group3[l].questions[i].aprqtid;
           this.objhdnvalue.tchresidh=this.arrquestions[j].group2[k].group3[l].questions[i].residh;
           this.objhdnvalue.tchresidd=this.arrquestions[j].group2[k].group3[l].questions[i].residd;
             
           }
              else if(this.arrquestions[j].group2[k].group3[l].questions[i].aprqtid == "254")
           {
           this.objhdnvalue.semaprqtid=this.arrquestions[j].group2[k].group3[l].questions[i].aprqtid;
           this.objhdnvalue.semresidh=this.arrquestions[j].group2[k].group3[l].questions[i].residh;
           this.objhdnvalue.semresidd =this.arrquestions[j].group2[k].group3[l].questions[i].residd;
             
           }
           else if(this.arrquestions[j].group2[k].group3[l].questions[i].aprqtid == "255")
           {
           this.objhdnvalue.repaprqtid=this.arrquestions[j].group2[k].group3[l].questions[i].aprqtid;
           this.objhdnvalue.represidh=this.arrquestions[j].group2[k].group3[l].questions[i].residh;
           this.objhdnvalue.represidd =this.arrquestions[j].group2[k].group3[l].questions[i].residd;
             
           }

              else  if(this.arrquestions[j].group2[k].group3[l].questions[i].aprqtid == "261")
           {
           this.objhdnvalue.resaprqtid=this.arrquestions[j].group2[k].group3[l].questions[i].aprqtid;
           this.objhdnvalue.resresidh=this.arrquestions[j].group2[k].group3[l].questions[i].residh;
           this.objhdnvalue.resresidd =this.arrquestions[j].group2[k].group3[l].questions[i].residd;
             
           }

           else if(this.arrquestions[j].group2[k].group3[l].questions[i].aprqtid == "262")
           {
           this.objhdnvalue.pubaprqtid=this.arrquestions[j].group2[k].group3[l].questions[i].aprqtid;
           this.objhdnvalue.pubresidh=this.arrquestions[j].group2[k].group3[l].questions[i].residh;
           this.objhdnvalue.pubresidd =this.arrquestions[j].group2[k].group3[l].questions[i].residd;
             
           }

           else if(this.arrquestions[j].group2[k].group3[l].questions[i].aprqtid == "263")
           {
           this.objhdnvalue.econaprqtid=this.arrquestions[j].group2[k].group3[l].questions[i].aprqtid;
           this.objhdnvalue.econresidh=this.arrquestions[j].group2[k].group3[l].questions[i].residh;
           this.objhdnvalue.econresidd =this.arrquestions[j].group2[k].group3[l].questions[i].residd;
             
           }
           else 
           {
          //  this.objhdnvalue.econaprqtid=this.arrquestions[j].group2[k].group3[l].questions[i].aprqtid;
           this.objhdnvalue.residh=this.arrquestions[j].group2[k].group3[l].questions[i].residh;
           console.log('residh',this.objhdnvalue.residh);
          //  this.objhdnvalue.econresidd =this.arrquestions[j].group2[k].group3[l].questions[i].residd;
             
           }
           
           }
         }
         }
         }
       }
       
   
     
      
     
     
       printform(residh){
         debugger;
           var clcd=localStorage.getItem('clcd');
           var aycd=localStorage.getItem('aycd');
           var masclid=localStorage.getItem('masclid');
           var usid=localStorage.getItem('usid');
            var url=this.aservice.callurl+"fpdf181/pdfreports/aprsl_lect.php?"+clcd+"&aycd="+aycd+"&ayid="+aycd+"&residh="+residh+"&emid="+usid+"&aprfmid=6&masclid="+masclid;
            window.open(url,'','');
          }
     
          openqrdl(content)
     {
       // this.objqrprint.bkid=bkid;
       // this.objqrprint.nobc=1;
       this.fmodel.qrdoctype='2Upevlstubar';
     
     
       this.modalRef=this.modalService.open(content,this.smmodalOptions);
       
       this.modalRef.result.then((result) => {
      
            // this.Asmtdetls(asid);
             this.closeResult = `Closed with: ${result}`;
         }, (reason) => {
             // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
         });
     }
     
          printqrlabels(obj){
           debugger;
             var clcd=localStorage.getItem('clcd');
             var aycd=localStorage.getItem('aycd');
              var url=this.aservice.callurl+"qrcode/"+obj.qrdoctype+".php?clcd="+clcd+"&aycd="+aycd+"&clid="+obj.clid+"&scid="+obj.secid+"&crid="+obj.crid+"&rmid="+obj.rmid;
              window.open(url,'','');
            }
       
          expbarlist(obj){
           debugger;
             var clcd=localStorage.getItem('clcd');
             var aycd=localStorage.getItem('aycd');
              var url=this.aservice.callurl+"export/expcsv_roomallot.php?clcd="+clcd+"&aycd="+aycd+"&clid="+obj.clid+"&scid="+obj.secid+"&crid="+obj.crid+"&rmid="+obj.rmid;
              window.open(url,'');
            }
         
       
     
     // Savedetails()
     // {
     
     //   console.log('savearr',this.attdata);
     // }
     
     
     
     
     
     saveappraisal()
     {
   var feedarr:any=[];
   var tag=true
       outerloop:for(let j=0;j<this.arrquestions.length;j++)
         {
   
           for (let k=0;k<this.arrquestions[j].group2.length;k++)
           {
             for(let l=0;l<this.arrquestions[j].group2[k].group3.length;l++)
             {
           for(let i=0;i<this.arrquestions[j].group2[k].group3[l].questions.length;i++)
           {
           let objitm:any={};
           if(this.arrquestions[j].group2[k].group3[l].questions[i].aprqtres.trim() == "")
           {
             alert('Please fill all the details');
             tag=false;
             break outerloop;
           }
             objitm.aprqtid=this.arrquestions[j].group2[k].group3[l].questions[i].aprqtid;
           objitm.residh=this.arrquestions[j].group2[k].group3[l].questions[i].residh;
           objitm.residd=this.arrquestions[j].group2[k].group3[l].questions[i].residd;
           objitm.aprqtres=this.arrquestions[j].group2[k].group3[l].questions[i].aprqtres.trim();
           objitm.aprqtrmk1=this.arrquestions[j].group2[k].group3[l].questions[i].aprqtrmk1.trim()
           objitm.aprqtrmk2=this.arrquestions[j].group2[k].group3[l].questions[i].aprqtrmk2.trim();
           console.log('objitm',objitm);
           feedarr.push(objitm);
           
           }
         }
         }
         }
   
          // console.log('SavegenmasDetails', JSON.parse(feedarr));
         if(tag)
         { 
         var pst={step:1,emid:"",loopdata:feedarr};
    
     this.apservice.saveappraisal(pst)
           .subscribe(
           result => {
               console.log('SavegenmasDetails', result);
               //this.suppliers = resultArray;
               alert(result.message);
               if(result.status=='success')
               {
                 
              //  this.SelectAttdDetails();
               }
              else
              {
     
              }
           },
           error =>{ alert('Error While saving...');}
           )
     
     console.log('data',feedarr);
     }
   }



   
     saveappraisalteach()
     {
  //  var feedarr=[];
   var tag=true;
        if(this.arrobjteaching.length<1)
        {
alert('Please add atleast one record');
tag=false;
        }
         if(tag)
         { 

        //    outerloop:for(let j=0;j<this.arrquestions.length;j++)
        //  {
   
        //    for (let k=0;k<this.arrquestions[j].group2.length;k++)
        //    {
        //      for(let l=0;l<this.arrquestions[j].group2[k].group3.length;l++)
        //      {
        //    for(let i=0;i<this.arrquestions[j].group2[k].group3[l].questions.length;i++)
        //    {
        //    let objitm:any={};
        //    if(this.arrquestions[j].group2[k].group3[l].questions[i].aprqtid == "253")
        //    {
        //    this.objhdnvalue.tchaprqtid=this.arrquestions[j].group2[k].group3[l].questions[i].aprqtid;
        //    this.objhdnvalue.tchresidh=this.arrquestions[j].group2[k].group3[l].questions[i].residh;
        //    this.objhdnvalue.tchresidd=this.arrquestions[j].group2[k].group3[l].questions[i].residd;
        //      break outerloop;
        //    }
            
           
        //    }
        //  }
        //  }
        //  }
         var pst={aprqtid:this.objhdnvalue.tchaprqtid,residh:this.objhdnvalue.tchresidh,residd:this.objhdnvalue.tchresidd,loopdata:this.arrobjteaching};
    
     this.apservice.saveappraisalhedet(pst)
           .subscribe(
           result => {
               console.log('SavegenmasDetails', result);
               //this.suppliers = resultArray;
               alert(result.message);
               if(result.status=='success')
               {
                this.arrobjteaching=[];
                //  this.arrobjteaching.push({aynm:'' , sem:'' , subhandle:'' , noclassign:'' , noclastougt:'' , unresults:'' , topicnm:'' , institenm:'' , wkdt:this.fmodel.attdt , place:'' , rectpnm:'' , issnisbnno:'' , impactfactor:'' , noofauthor:'' , mainauthor:'' , recscore:'' , chapternm:'' , econtdet:''});
               this.selappraisalhedet(this.objhdnvalue.tchaprqtid,this.objhdnvalue.tchresidh,this.objhdnvalue.tchresidd);
               }
              else
              {
     
              }
           },
           error =>{ alert('Error While saving...');}
           )
     
     
     }
   }



     saveappraisalsem()
     {
  //  var feedarr=[];
   var tag=true;
        if(this.arrobjseminar.length<1)
        {
alert('Please add atleast one record');
tag=false;
        }
         if(tag)
         { 

        //    outerloop:for(let j=0;j<this.arrquestions.length;j++)
        //  {
   
        //    for (let k=0;k<this.arrquestions[j].group2.length;k++)
        //    {
        //      for(let l=0;l<this.arrquestions[j].group2[k].group3.length;l++)
        //      {
        //    for(let i=0;i<this.arrquestions[j].group2[k].group3[l].questions.length;i++)
        //    {
        //    let objitm:any={};
        //    if(this.arrquestions[j].group2[k].group3[l].questions[i].aprqtid == "253")
        //    {
        //    this.objhdnvalue.tchaprqtid=this.arrquestions[j].group2[k].group3[l].questions[i].aprqtid;
        //    this.objhdnvalue.tchresidh=this.arrquestions[j].group2[k].group3[l].questions[i].residh;
        //    this.objhdnvalue.tchresidd=this.arrquestions[j].group2[k].group3[l].questions[i].residd;
        //      break outerloop;
        //    }
            
           
        //    }
        //  }
        //  }
        //  }
         var pst={aprqtid:this.objhdnvalue.semaprqtid,residh:this.objhdnvalue.semresidh,residd:this.objhdnvalue.semresidd,loopdata:this.arrobjseminar};
    
     this.apservice.saveappraisalhedet(pst)
           .subscribe(
           result => {
               console.log('SavegenmasDetails', result);
               //this.suppliers = resultArray;
               alert(result.message);
               if(result.status=='success')
               {
                this.arrobjseminar=[];
                //  this.arrobjseminar.push({aynm:'' , sem:'' , subhandle:'' , noclassign:'' , noclastougt:'' , unresults:'' , topicnm:'' , institenm:'' , wkdt:this.fmodel.attdt , place:'' , rectpnm:'' , issnisbnno:'' , impactfactor:'' , noofauthor:'' , mainauthor:'' , recscore:'' , chapternm:'' , econtdet:''});
               this.selappraisalhedet(this.objhdnvalue.semaprqtid,this.objhdnvalue.semresidh,this.objhdnvalue.semresidd);
               }
              else
              {
     
              }
           },
           error =>{ alert('Error While saving...');}
           )
     
     
     }
   }


     saveappraisalrep()
     {
  //  var feedarr=[];
   var tag=true;
        if(this.arrobjrep.length<1)
        {
alert('Please add atleast one record');
tag=false;
        }
         if(tag)
         { 

       
         var pst={aprqtid:this.objhdnvalue.repaprqtid,residh:this.objhdnvalue.represidh,residd:this.objhdnvalue.represidd,loopdata:this.arrobjrep};
    
     this.apservice.saveappraisalhedet(pst)
           .subscribe(
           result => {
               console.log('SavegenmasDetails', result);
               //this.suppliers = resultArray;
               alert(result.message);
               if(result.status=='success')
               {
                this.arrobjrep=[];
                //  this.arrobjrep.push({aynm:'' , sem:'' , subhandle:'' , noclassign:'' , noclastougt:'' , unresults:'' , topicnm:'' , institenm:'' , wkdt:this.fmodel.attdt , place:'' , rectpnm:'' , issnisbnno:'' , impactfactor:'' , noofauthor:'' , mainauthor:'' , recscore:'' , chapternm:'' , econtdet:''});
               this.selappraisalhedet(this.objhdnvalue.repaprqtid,this.objhdnvalue.represidh,this.objhdnvalue.represidd);
               }
              else
              {
     
              }
           },
           error =>{ alert('Error While saving...');}
           )
     
     
     }
   }


     saveappraisalres()
     {
  //  var feedarr=[];
   var tag=true;
        if(this.arrobjres.length<1)
        {
alert('Please add atleast one record');
tag=false;
        }
         if(tag)
         { 

       
         var pst={aprqtid:this.objhdnvalue.resaprqtid,residh:this.objhdnvalue.resresidh,residd:this.objhdnvalue.resresidd,loopdata:this.arrobjres};
    
     this.apservice.saveappraisalhedet(pst)
           .subscribe(
           result => {
               console.log('SavegenmasDetails', result);
               //this.suppliers = resultArray;
               alert(result.message);
               if(result.status=='success')
               {
                this.arrobjres=[];
                //  this.arrobjrep.push({aynm:'' , sem:'' , subhandle:'' , noclassign:'' , noclastougt:'' , unresults:'' , topicnm:'' , institenm:'' , wkdt:this.fmodel.attdt , place:'' , rectpnm:'' , issnisbnno:'' , impactfactor:'' , noofauthor:'' , mainauthor:'' , recscore:'' , chapternm:'' , econtdet:''});
               this.selappraisalhedet(this.objhdnvalue.resaprqtid,this.objhdnvalue.resresidh,this.objhdnvalue.resresidd);
               }
              else
              {
     
              }
           },
           error =>{ alert('Error While saving...');}
           )
     
     
     }
   }


     saveappraisalpub()
     {
  //  var feedarr=[];
   var tag=true;
        if(this.arrobjpub.length<1)
        {
alert('Please add atleast one record');
tag=false;
        }
         if(tag)
         { 

       
         var pst={aprqtid:this.objhdnvalue.pubaprqtid,residh:this.objhdnvalue.pubresidh,residd:this.objhdnvalue.pubresidd,loopdata:this.arrobjpub};
    
     this.apservice.saveappraisalhedet(pst)
           .subscribe(
           result => {
               console.log('SavegenmasDetails', result);
               //this.suppliers = resultArray;
               alert(result.message);
               if(result.status=='success')
               {
                this.arrobjpub=[];
                //  this.arrobjrep.push({aynm:'' , sem:'' , subhandle:'' , noclassign:'' , noclastougt:'' , unresults:'' , topicnm:'' , institenm:'' , wkdt:this.fmodel.attdt , place:'' , rectpnm:'' , issnisbnno:'' , impactfactor:'' , noofauthor:'' , mainauthor:'' , recscore:'' , chapternm:'' , econtdet:''});
               this.selappraisalhedet(this.objhdnvalue.pubaprqtid,this.objhdnvalue.pubresidh,this.objhdnvalue.pubresidd);
               }
              else
              {
     
              }
           },
           error =>{ alert('Error While saving...');}
           )
     
     
     }
   }



     saveappraisalecon()
     {
  //  var feedarr=[];
   var tag=true;
        if(this.arrobjecon.length<1)
        {
alert('Please add atleast one record');
tag=false;
        }
         if(tag)
         { 

       
         var pst={aprqtid:this.objhdnvalue.econaprqtid,residh:this.objhdnvalue.econresidh,residd:this.objhdnvalue.econresidd,loopdata:this.arrobjecon};
    
     this.apservice.saveappraisalhedet(pst)
           .subscribe(
           result => {
               console.log('SavegenmasDetails', result);
               //this.suppliers = resultArray;
               alert(result.message);
               if(result.status=='success')
               {
                this.arrobjecon=[];
                //  this.arrobjrep.push({aynm:'' , sem:'' , subhandle:'' , noclassign:'' , noclastougt:'' , unresults:'' , topicnm:'' , institenm:'' , wkdt:this.fmodel.attdt , place:'' , rectpnm:'' , issnisbnno:'' , impactfactor:'' , noofauthor:'' , mainauthor:'' , recscore:'' , chapternm:'' , econtdet:''});
               this.selappraisalhedet(this.objhdnvalue.econaprqtid,this.objhdnvalue.econresidh,this.objhdnvalue.econresidd);
               }
              else
              {
     
              }
           },
           error =>{ alert('Error While saving...');}
           )
     
     
     }
   }



selappraisalhedet(qtid, ridh, ridd)
{
  // var pst={qtid:qtid,ridh:ridh,ridd:ridd};
  this.apservice.selappraisalhedet(qtid, ridh, ridd)
        .subscribe(resultArray => {
                 console.log('ret-by-atd', resultArray);

                 if(qtid == "253")
                 {
                 this.arrteaching = resultArray;
                 }
                 else if(qtid == "254")
                 {
                   this.arrseminar = resultArray;
                  //  this.bindfields();
                 }
                 else if(qtid == "255")
                 {
                   this.arrrep = resultArray;
                  //  this.bindfields();
                 }
      else if(qtid == "261")
                 {
                   this.arrres = resultArray;
                  //  this.bindfields();
                 }
                  else if(qtid == "262")
                 {
                   this.arrpub = resultArray;
                  //  this.bindfields();
                 }
                  else if(qtid == "263")
                 {
                   this.arrecon = resultArray;
                  //  this.bindfields();
                 }
                 //alert(resultArray.message);
     
             }, error =>
                 alert('error in connection')
             );
     }
     

   addteach()
{
  
  // console.log('arrvoc',this.arrvocdet);
  // this.getacchead1();
this.arrobjteaching.push({aynm:'' , sem:'' , subhandle:'' , noclassign:'' , noclastougt:'' , unresults:'' , topicnm:'' , institenm:'' , wkdt:this.fmodel.attdt , place:'' , rectpnm:'' , issnisbnno:'' , impactfactor:'' , noofauthor:'' , mainauthor:'' , recscore:'' , chapternm:'' , econtdet:''});
console.log('arrvoc1',this.arrobjteaching);

}

remteach(index)
{
  
  this.arrobjteaching.splice(index, 1);
         if (this.arrobjteaching.length === 0) {
             this.arrobjteaching = [];
         }

}

 addsem()
{
  
  // console.log('arrvoc',this.arrvocdet);
  // this.getacchead1();
this.arrobjseminar.push({aynm:'' , sem:'' , subhandle:'' , noclassign:'' , noclastougt:'' , unresults:'' , topicnm:'' , institenm:'' , wkdt:this.fmodel.attdt , place:'' , rectpnm:'' , issnisbnno:'' , impactfactor:'' , noofauthor:'' , mainauthor:'' , recscore:'' , chapternm:'' , econtdet:''});
console.log('arrvoc1',this.arrobjseminar);

}

remsem(index)
{
  
  this.arrobjseminar.splice(index, 1);
         if (this.arrobjseminar.length === 0) {
             this.arrobjseminar = [];
         }

}

 addrep()
{
  
  // console.log('arrvoc',this.arrvocdet);
  // this.getacchead1();
this.arrobjrep.push({aynm:'' , sem:'' , subhandle:'' , noclassign:'' , noclastougt:'' , unresults:'' , topicnm:'' , institenm:'' , wkdt:this.fmodel.attdt , place:'' , rectpnm:'National' , issnisbnno:'' , impactfactor:'' , noofauthor:'' , mainauthor:'' , recscore:'' , chapternm:'' , econtdet:''});
console.log('arrvoc1',this.arrobjseminar);

}

remrep(index)
{
  
  this.arrobjrep.splice(index, 1);
         if (this.arrobjrep.length === 0) {
             this.arrobjrep = [];
         }

}

 addres()
{
  
  // console.log('arrvoc',this.arrvocdet);
  // this.getacchead1();
this.arrobjres.push({aynm:'' , sem:'' , subhandle:'' , noclassign:'' , noclastougt:'' , unresults:'' , topicnm:'' , institenm:'' , wkdt:this.fmodel.attdt , place:'' , rectpnm:'National' , issnisbnno:'' , impactfactor:'' , noofauthor:'' , mainauthor:'' , recscore:'' , chapternm:'' , econtdet:''});
// console.log('arrvoc1',this.arrobjseminar);

}

remres(index)
{
  
  this.arrobjres.splice(index, 1);
         if (this.arrobjres.length === 0) {
             this.arrobjres = [];
         }

}

        


 addpub()
{
  
  // console.log('arrvoc',this.arrvocdet);
  // this.getacchead1();
this.arrobjpub.push({aynm:'' , sem:'' , subhandle:'' , noclassign:'' , noclastougt:'' , unresults:'' , topicnm:'' , institenm:'' , wkdt:this.fmodel.attdt , place:'' , rectpnm:'National' , issnisbnno:'' , impactfactor:'' , noofauthor:'' , mainauthor:'' , recscore:'' , chapternm:'' , econtdet:''});
// console.log('arrvoc1',this.arrobjseminar);

}

rempub(index)
{
  
  this.arrobjpub.splice(index, 1);
         if (this.arrobjpub.length === 0) {
             this.arrobjpub = [];
         }

}
 addecon()
{
  
  // console.log('arrvoc',this.arrvocdet);
  // this.getacchead1();
this.arrobjecon.push({aynm:'' , sem:'' , subhandle:'' , noclassign:'' , noclastougt:'' , unresults:'' , topicnm:'' , institenm:'' , wkdt:this.fmodel.attdt , place:'' , rectpnm:'National' , issnisbnno:'' , impactfactor:'' , noofauthor:'' , mainauthor:'' , recscore:'' , chapternm:'' , econtdet:''});
// console.log('arrvoc1',this.arrobjseminar);

}

remcon(index)
{
  
  this.arrobjecon.splice(index, 1);
         if (this.arrobjecon.length === 0) {
             this.arrobjecon = [];
         }

}

  delappraisalhedet(apransid,tag)
     {
  //  var feedarr=[];
 if (confirm("Are you sure to delete this record?")) {
       
         var pst={apransid:apransid};
    
     this.apservice.delappraisalhedet(pst)
           .subscribe(
           result => {
               console.log('SavegenmasDetails', result);
               //this.suppliers = resultArray;
               alert(result.message);
               if(result.status=='success')
               {
                if(tag == "teach")
                {
                   this.selappraisalhedet(this.objhdnvalue.tchaprqtid,this.objhdnvalue.tchresidh,this.objhdnvalue.tchresidd);
                }
else if(tag == "sem")
                {
                   this.selappraisalhedet(this.objhdnvalue.semaprqtid,this.objhdnvalue.semresidh,this.objhdnvalue.semresidd);
                }
else if(tag == "rep")
                {
                   this.selappraisalhedet(this.objhdnvalue.repaprqtid,this.objhdnvalue.represidh,this.objhdnvalue.represidd);
                }
else if(tag == "res")
                {
                   this.selappraisalhedet(this.objhdnvalue.resaprqtid,this.objhdnvalue.resresidh,this.objhdnvalue.resresidd);
                }
else if(tag == "pub")
                {
                   this.selappraisalhedet(this.objhdnvalue.pubaprqtid,this.objhdnvalue.pubresidh,this.objhdnvalue.pubresidd);
                }
else if(tag == "econ")
                {
                   this.selappraisalhedet(this.objhdnvalue.econaprqtid,this.objhdnvalue.econresidh,this.objhdnvalue.econresidd);
                }

               }
              else
              {
     
              }
           },
           error =>{ alert('Error While saving...');}
           )
     
     
     
   }
  }

     }
     
   
